// Generated by apps/web/scripts/generate-country-names.mjs — do not edit by hand.
import type { Locale } from "../../i18n/locales";

export type CountryNames = Record<Locale, string>;

export const countryNamesBySlug: Record<string, CountryNames> = {
  "albanie": {
    "nl": "Albanië",
    "en": "Albania",
    "de": "Albanien",
    "fr": "Albanie",
    "es": "Albania"
  },
  "algerije": {
    "nl": "Algerije",
    "en": "Algeria",
    "de": "Algerien",
    "fr": "Algérie",
    "es": "Argelia"
  },
  "amerikaans-samoa": {
    "nl": "Amerikaans-Samoa",
    "en": "American Samoa",
    "de": "Amerikanisch-Samoa",
    "fr": "Samoa américaines",
    "es": "Samoa Americana"
  },
  "amerikaanse-maagdeneilanden": {
    "nl": "Amerikaanse Maagdeneilanden",
    "en": "Virgin Islands, U.S.",
    "de": "Amerikanische Jungferninseln",
    "fr": "Îles Vierges des États-Unis",
    "es": "Islas Vírgenes de los Estados Unidos"
  },
  "andorra": {
    "nl": "Andorra",
    "en": "Andorra",
    "de": "Andorra",
    "fr": "Andorre",
    "es": "Andorra"
  },
  "angola": {
    "nl": "Angola",
    "en": "Angola",
    "de": "Angola",
    "fr": "Angola",
    "es": "Angola"
  },
  "anguilla": {
    "nl": "Anguilla (Brits overzees gebied)",
    "en": "Anguilla (Brits overzees gebied)",
    "de": "Anguilla (Brits overzees gebied)",
    "fr": "Anguilla (Brits overzees gebied)",
    "es": "Anguila (Brits overzees gebied)"
  },
  "antigua-en-barbuda": {
    "nl": "Antigua en Barbuda",
    "en": "Antigua and Barbuda",
    "de": "Antigua und Barbuda",
    "fr": "Antigua-et-Barbuda",
    "es": "Antigua y Barbuda"
  },
  "argentinie": {
    "nl": "Argentinië",
    "en": "Argentina",
    "de": "Argentinien",
    "fr": "Argentine",
    "es": "Argentina"
  },
  "armenie": {
    "nl": "Armenië",
    "en": "Armenia",
    "de": "Armenien",
    "fr": "Arménie",
    "es": "Armenia"
  },
  "aruba": {
    "nl": "Aruba",
    "en": "Aruba",
    "de": "Aruba",
    "fr": "Aruba",
    "es": "Aruba"
  },
  "australie": {
    "nl": "Australië",
    "en": "Australia",
    "de": "Australien",
    "fr": "Australie",
    "es": "Australia"
  },
  "azerbeidzjan": {
    "nl": "Azerbeidzjan",
    "en": "Azerbaijan",
    "de": "Aserbaidschan",
    "fr": "Azerbaïdjan",
    "es": "Azerbaiyán"
  },
  "bahamas": {
    "nl": "Bahama's",
    "en": "Bahamas",
    "de": "Bahamas",
    "fr": "Bahamas",
    "es": "Bahamas"
  },
  "bangladesh": {
    "nl": "Bangladesh",
    "en": "Bangladesh",
    "de": "Bangladesch",
    "fr": "Bangladesh",
    "es": "Bangladés"
  },
  "barbados": {
    "nl": "Barbados",
    "en": "Barbados",
    "de": "Barbados",
    "fr": "Barbade",
    "es": "Barbados"
  },
  "belgie": {
    "nl": "België",
    "en": "Belgium",
    "de": "Belgien",
    "fr": "Belgique",
    "es": "Bélgica"
  },
  "belize": {
    "nl": "Belize",
    "en": "Belize",
    "de": "Belize",
    "fr": "Belize",
    "es": "Belice"
  },
  "benin": {
    "nl": "Benin",
    "en": "Benin",
    "de": "Benin",
    "fr": "Bénin",
    "es": "Benín"
  },
  "bermuda": {
    "nl": "Bermuda (Brits overzees gebied)",
    "en": "Bermuda (Brits overzees gebied)",
    "de": "Bermuda (Brits overzees gebied)",
    "fr": "Bermudes (Brits overzees gebied)",
    "es": "Bermudas (Brits overzees gebied)"
  },
  "bhutan": {
    "nl": "Bhutan",
    "en": "Bhutan",
    "de": "Bhutan",
    "fr": "Bhoutan",
    "es": "Bután"
  },
  "bolivia": {
    "nl": "Bolivia",
    "en": "Bolivia",
    "de": "Bolivien",
    "fr": "Bolivie",
    "es": "Bolivia"
  },
  "bonaire": {
    "nl": "Bonaire",
    "en": "Bonaire, Sint Eustatius and Saba",
    "de": "Karibische Niederlande",
    "fr": "Pays-Bas caribéens",
    "es": "Caribe neerlandés"
  },
  "bosnie-en-herzegovina": {
    "nl": "Bosnië en Herzegovina",
    "en": "Bosnia and Herzegovina",
    "de": "Bosnien und Herzegowina",
    "fr": "Bosnie-Herzégovine",
    "es": "Bosnia y Herzegovina"
  },
  "botswana": {
    "nl": "Botswana",
    "en": "Botswana",
    "de": "Botswana",
    "fr": "Botswana",
    "es": "Botsuana"
  },
  "brazilie": {
    "nl": "Brazilië",
    "en": "Brazil",
    "de": "Brasilien",
    "fr": "Brésil",
    "es": "Brasil"
  },
  "britse-maagdeneilanden": {
    "nl": "Britse Maagdeneilanden",
    "en": "Virgin Islands, British",
    "de": "Britische Jungferninseln",
    "fr": "Îles Vierges britanniques",
    "es": "Islas Vírgenes Británicas"
  },
  "brunei-darussalam": {
    "nl": "Brunei Darussalam",
    "en": "Brunei",
    "de": "Brunei Darussalam",
    "fr": "Brunei",
    "es": "Brunéi"
  },
  "bulgarije": {
    "nl": "Bulgarije",
    "en": "Bulgaria",
    "de": "Bulgarien",
    "fr": "Bulgarie",
    "es": "Bulgaria"
  },
  "burkina-faso": {
    "nl": "Burkina Faso",
    "en": "Burkina Faso",
    "de": "Burkina Faso",
    "fr": "Burkina Faso",
    "es": "Burkina Faso"
  },
  "burundi": {
    "nl": "Burundi",
    "en": "Burundi",
    "de": "Burundi",
    "fr": "Burundi",
    "es": "Burundi"
  },
  "cambodja": {
    "nl": "Cambodja",
    "en": "Cambodia",
    "de": "Kambodscha",
    "fr": "Cambodge",
    "es": "Camboya"
  },
  "canada": {
    "nl": "Canada",
    "en": "Canada",
    "de": "Kanada",
    "fr": "Canada",
    "es": "Canadá"
  },
  "centraal-afrikaanse-republiek": {
    "nl": "Centraal-Afrikaanse Republiek",
    "en": "Central African Republic",
    "de": "Zentralafrikanische Republik",
    "fr": "République centrafricaine",
    "es": "República Centroafricana"
  },
  "chagosarchipel": {
    "nl": "Chagosarchipel (Brits territorium Indische oceaan)",
    "en": "United Kingdom (Brits territorium Indische oceaan)",
    "de": "Vereinigtes Königreich (Brits territorium Indische oceaan)",
    "fr": "Royaume-Uni (Brits territorium Indische oceaan)",
    "es": "Reino Unido (Brits territorium Indische oceaan)"
  },
  "chili": {
    "nl": "Chili (incl. Paaseiland)",
    "en": "Chile (incl. Paaseiland)",
    "de": "Chile (incl. Paaseiland)",
    "fr": "Chili (incl. Paaseiland)",
    "es": "Chile (incl. Paaseiland)"
  },
  "china": {
    "nl": "China",
    "en": "China",
    "de": "China",
    "fr": "Chine",
    "es": "China"
  },
  "china-hongkong": {
    "nl": "China-Hongkong",
    "en": "Hong Kong",
    "de": "Sonderverwaltungsregion Hongkong",
    "fr": "R.A.S. chinoise de Hong Kong",
    "es": "RAE de Hong Kong (China)"
  },
  "china-macau": {
    "nl": "China-Macau",
    "en": "Macao",
    "de": "Sonderverwaltungsregion Macau",
    "fr": "R.A.S. chinoise de Macao",
    "es": "RAE de Macao (China)"
  },
  "china-taiwan": {
    "nl": "China-Taiwan",
    "en": "Taiwan, Province of China",
    "de": "Taiwan",
    "fr": "Taïwan",
    "es": "Taiwán"
  },
  "christmaseiland": {
    "nl": "Christmaseiland (Australië)",
    "en": "Christmas Island (Australia)",
    "de": "Weihnachtsinsel (Australien)",
    "fr": "Île Christmas (Australie)",
    "es": "Isla de Navidad (Australia)"
  },
  "colombia": {
    "nl": "Colombia",
    "en": "Colombia",
    "de": "Kolumbien",
    "fr": "Colombie",
    "es": "Colombia"
  },
  "comoren": {
    "nl": "Comoren",
    "en": "Comoros",
    "de": "Komoren",
    "fr": "Comores",
    "es": "Comoras"
  },
  "congo": {
    "nl": "Congo (Brazzaville)",
    "en": "Congo (Brazzaville)",
    "de": "Kongo-Brazzaville",
    "fr": "Congo-Brazzaville",
    "es": "Congo (Brazzaville)"
  },
  "congo-dr": {
    "nl": "Congo D.R. (Kinshasa)",
    "en": "Congo, the Democratic Republic of the (Kinshasa)",
    "de": "Kongo-Kinshasa",
    "fr": "Congo-Kinshasa",
    "es": "República Democrática del Congo (Kinshasa)"
  },
  "cookeilanden": {
    "nl": "Cookeilanden (Nieuw-Zeeland)",
    "en": "Cook Islands (New Zealand)",
    "de": "Cookinseln (Neuseeland)",
    "fr": "Îles Cook (Nouvelle-Zélande)",
    "es": "Islas Cook (Nueva Zelanda)"
  },
  "coral-sea-eilanden": {
    "nl": "Coral Sea eilanden (Australië)",
    "en": "Coral Sea Islands (Australia)",
    "de": "Coral-Sea-Inseln (Australien)",
    "fr": "Îles de la mer de Corail (Australie)",
    "es": "Islas del mar de Coral (Australia)"
  },
  "costa-rica": {
    "nl": "Costa Rica",
    "en": "Costa Rica",
    "de": "Costa Rica",
    "fr": "Costa Rica",
    "es": "Costa Rica"
  },
  "palau": {
    "nl": "Palau",
    "en": "Palau",
    "de": "Palau",
    "fr": "Palaos",
    "es": "Palaos"
  },
  "libanon": {
    "nl": "Libanon",
    "en": "Lebanon",
    "de": "Libanon",
    "fr": "Liban",
    "es": "Líbano"
  },
  "palestijnse-gebieden": {
    "nl": "Palestijnse Gebieden",
    "en": "Palestinian Territory, Occupied",
    "de": "Palästinensisches Gebiet",
    "fr": "Palestine (territoire occupé)",
    "es": "Territorio Palestino Ocupado"
  },
  "tunesie": {
    "nl": "Tunesië",
    "en": "Tunisia",
    "de": "Tunesien",
    "fr": "Tunisie",
    "es": "Túnez"
  },
  "hawaii": {
    "nl": "Hawaii (Verenigde Staten)",
    "en": "Hawaii (Verenigde Staten) (United States)",
    "de": "Hawaii (Verenigde Staten) (Vereinigte Staaten)",
    "fr": "Hawaii (Verenigde Staten) (États-Unis)",
    "es": "Hawaii (Verenigde Staten) (Estados Unidos)"
  },
  "micronesie": {
    "nl": "Micronesië (de Federale Staten van)",
    "en": "Micronesia, Federated States of",
    "de": "Mikronesien (Föderierte Staaten von)",
    "fr": "Micronésie (États fédérés de)",
    "es": "Micronesia (Estados Federados de)"
  },
  "oostenrijk": {
    "nl": "Oostenrijk",
    "en": "Austria",
    "de": "Österreich",
    "fr": "Autriche",
    "es": "Austria"
  },
  "italie": {
    "nl": "Italië",
    "en": "Italy",
    "de": "Italien",
    "fr": "Italie",
    "es": "Italia"
  },
  "franse-antillen": {
    "nl": "Franse Antillen (Guadeloupe, Martinique, St Barthélemy & St Martin)",
    "en": "Franse Antillen (Guadeloupe, Martinique, St Barthélemy & St Martin)",
    "de": "Franse Antillen (Guadeloupe, Martinique, St Barthélemy & St Martin)",
    "fr": "Franse Antillen (Guadeloupe, Martinique, St Barthélemy & St Martin)",
    "es": "Franse Antillen (Guadeloupe, Martinique, St Barthélemy & St Martin)"
  },
  "nieuw-caledonie": {
    "nl": "Nieuw-Caledonië (Frans overzees gebied)",
    "en": "New Caledonia (Frans overzees gebied)",
    "de": "Neukaledonien (Frans overzees gebied)",
    "fr": "Nouvelle-Calédonie (Frans overzees gebied)",
    "es": "Nueva Caledonia (Frans overzees gebied)"
  },
  "trinidad-en-tobago": {
    "nl": "Trinidad en Tobago",
    "en": "Trinidad and Tobago",
    "de": "Trinidad und Tobago",
    "fr": "Trinité-et-Tobago",
    "es": "Trinidad y Tobago"
  },
  "kazachstan": {
    "nl": "Kazachstan",
    "en": "Kazakhstan",
    "de": "Kasachstan",
    "fr": "Kazakhstan",
    "es": "Kazajistán"
  },
  "india": {
    "nl": "India",
    "en": "India",
    "de": "Indien",
    "fr": "Inde",
    "es": "India"
  },
  "liechtenstein": {
    "nl": "Liechtenstein",
    "en": "Liechtenstein",
    "de": "Liechtenstein",
    "fr": "Liechtenstein",
    "es": "Liechtenstein"
  },
  "moldavie": {
    "nl": "Moldavië",
    "en": "Moldova, Republic of",
    "de": "Moldau (Republik)",
    "fr": "Moldavie (République de)",
    "es": "Moldavia (República de)"
  },
  "norfolkeiland": {
    "nl": "Norfolkeiland (Australië)",
    "en": "Norfolk Island (Australia)",
    "de": "Norfolkinsel (Australien)",
    "fr": "Île Norfolk (Australie)",
    "es": "Isla Norfolk (Australia)"
  },
  "denemarken": {
    "nl": "Denemarken",
    "en": "Denmark",
    "de": "Dänemark",
    "fr": "Danemark",
    "es": "Dinamarca"
  },
  "nepal": {
    "nl": "Nepal",
    "en": "Nepal",
    "de": "Nepal",
    "fr": "Népal",
    "es": "Nepal"
  },
  "turks-en-caicoseilanden": {
    "nl": "Turks- en Caicoseilanden",
    "en": "Turks and Caicos Islands",
    "de": "Turks- und Caicosinseln",
    "fr": "Îles Turques-et-Caïques",
    "es": "Islas Turcas y Caicos"
  },
  "sierra-leone": {
    "nl": "Sierra Leone",
    "en": "Sierra Leone",
    "de": "Sierra Leone",
    "fr": "Sierra Leone",
    "es": "Sierra Leona"
  },
  "kosovo": {
    "nl": "Kosovo",
    "en": "Kosovo",
    "de": "Kosovo",
    "fr": "Kosovo",
    "es": "Kosovo"
  },
  "kirgistan": {
    "nl": "Kirgistan (Kirgizië)",
    "en": "Kirgistan (Kirgizië)",
    "de": "Kirgistan (Kirgizië)",
    "fr": "Kirgistan (Kirgizië)",
    "es": "Kirgistan (Kirgizië)"
  },
  "nauru": {
    "nl": "Nauru",
    "en": "Nauru",
    "de": "Nauru",
    "fr": "Nauru",
    "es": "Nauru"
  },
  "westelijke-sahara": {
    "nl": "Westelijke Sahara",
    "en": "Western Sahara",
    "de": "Westsahara",
    "fr": "Sahara occidental",
    "es": "Sáhara Occidental"
  },
  "pitcairneilanden": {
    "nl": "Pitcairneilanden (Brits overzees gebied)",
    "en": "Pitcairn (Brits overzees gebied)",
    "de": "Pitcairninseln (Brits overzees gebied)",
    "fr": "Îles Pitcairn (Brits overzees gebied)",
    "es": "Islas Pitcairn (Brits overzees gebied)"
  },
  "saoedi-arabie": {
    "nl": "Saoedi-Arabië",
    "en": "Saudi Arabia",
    "de": "Saudi-Arabien",
    "fr": "Arabie saoudite",
    "es": "Arabia Saudita"
  },
  "oekraine": {
    "nl": "Oekraïne",
    "en": "Ukraine",
    "de": "Ukraine",
    "fr": "Ukraine",
    "es": "Ucrania"
  },
  "vanuatu": {
    "nl": "Vanuatu",
    "en": "Vanuatu",
    "de": "Vanuatu",
    "fr": "Vanuatu",
    "es": "Vanuatu"
  },
  "zambia": {
    "nl": "Zambia",
    "en": "Zambia",
    "de": "Sambia",
    "fr": "Zambie",
    "es": "Zambia"
  },
  "haiti": {
    "nl": "Haïti",
    "en": "Haiti",
    "de": "Haiti",
    "fr": "Haïti",
    "es": "Haití"
  },
  "georgie": {
    "nl": "Georgië",
    "en": "Georgia",
    "de": "Georgien",
    "fr": "Géorgie",
    "es": "Georgia"
  },
  "tuvalu": {
    "nl": "Tuvalu",
    "en": "Tuvalu",
    "de": "Tuvalu",
    "fr": "Tuvalu",
    "es": "Tuvalu"
  },
  "st-vincent-en-de-grenadines": {
    "nl": "St Vincent en de Grenadines",
    "en": "St Vincent en de Grenadines",
    "de": "St Vincent en de Grenadines",
    "fr": "St Vincent en de Grenadines",
    "es": "St Vincent en de Grenadines"
  },
  "turkmenistan": {
    "nl": "Turkmenistan",
    "en": "Turkmenistan",
    "de": "Turkmenistan",
    "fr": "Turkménistan",
    "es": "Turkmenistán"
  },
  "cyprus": {
    "nl": "Cyprus",
    "en": "Cyprus",
    "de": "Zypern",
    "fr": "Chypre",
    "es": "Chipre"
  },
  "faeroer": {
    "nl": "Faeroër",
    "en": "Faroe Islands",
    "de": "Färöer",
    "fr": "Îles Féroé",
    "es": "Islas Feroe"
  },
  "rwanda": {
    "nl": "Rwanda",
    "en": "Rwanda",
    "de": "Ruanda",
    "fr": "Rwanda",
    "es": "Ruanda"
  },
  "syrie": {
    "nl": "Syrië",
    "en": "Syrian Arab Republic",
    "de": "Arabische Republik Syrien",
    "fr": "République arabe syrienne",
    "es": "República Árabe Siria"
  },
  "guinee": {
    "nl": "Guinee (Conakry)",
    "en": "Guinea (Conakry)",
    "de": "Guinea (Conakry)",
    "fr": "Guinée (Conakry)",
    "es": "Guinea (Conakry)"
  },
  "marokko": {
    "nl": "Marokko",
    "en": "Morocco",
    "de": "Marokko",
    "fr": "Maroc",
    "es": "Marruecos"
  },
  "togo": {
    "nl": "Togo",
    "en": "Togo",
    "de": "Togo",
    "fr": "Togo",
    "es": "Togo"
  },
  "djibouti": {
    "nl": "Djibouti",
    "en": "Djibouti",
    "de": "Dschibuti",
    "fr": "Djibouti",
    "es": "Yibuti"
  },
  "st-kitts-en-nevis": {
    "nl": "St Kitts en Nevis",
    "en": "St Kitts en Nevis",
    "de": "St Kitts en Nevis",
    "fr": "St Kitts en Nevis",
    "es": "St Kitts en Nevis"
  },
  "tokelau": {
    "nl": "Tokelau (Nieuw-Zeeland)",
    "en": "Tokelau (New Zealand)",
    "de": "Tokelau (Neuseeland)",
    "fr": "Tokelau (Nouvelle-Zélande)",
    "es": "Tokelau (Nueva Zelanda)"
  },
  "zweden": {
    "nl": "Zweden",
    "en": "Sweden",
    "de": "Schweden",
    "fr": "Suède",
    "es": "Suecia"
  },
  "tanzania": {
    "nl": "Tanzania",
    "en": "Tanzania, United Republic of",
    "de": "Tansania (Vereinigte Republik)",
    "fr": "Tanzanie (République-Unie de)",
    "es": "Tanzania (República Unida de)"
  },
  "israel": {
    "nl": "Israël",
    "en": "Israel",
    "de": "Israel",
    "fr": "Israël",
    "es": "Israel"
  },
  "ghana": {
    "nl": "Ghana",
    "en": "Ghana",
    "de": "Ghana",
    "fr": "Ghana",
    "es": "Ghana"
  },
  "liberia": {
    "nl": "Liberia",
    "en": "Liberia",
    "de": "Liberia",
    "fr": "Liberia",
    "es": "Liberia"
  },
  "ecuador": {
    "nl": "Ecuador (incl. Galapagos eilanden)",
    "en": "Ecuador (incl. Galapagos eilanden)",
    "de": "Ecuador (incl. Galapagos eilanden)",
    "fr": "Équateur (incl. Galapagos eilanden)",
    "es": "Ecuador (incl. Galapagos eilanden)"
  },
  "laos": {
    "nl": "Laos (Democratische Volksrepubliek Laos)",
    "en": "Laos (Democratische Volksrepubliek Laos)",
    "de": "Laos (Democratische Volksrepubliek Laos)",
    "fr": "Laos (Democratische Volksrepubliek Laos)",
    "es": "Laos (Democratische Volksrepubliek Laos)"
  },
  "grenada": {
    "nl": "Grenada",
    "en": "Grenada",
    "de": "Grenada",
    "fr": "Grenade",
    "es": "Granada"
  },
  "guatemala": {
    "nl": "Guatemala",
    "en": "Guatemala",
    "de": "Guatemala",
    "fr": "Guatemala",
    "es": "Guatemala"
  },
  "tsjaad": {
    "nl": "Tsjaad",
    "en": "Chad",
    "de": "Tschad",
    "fr": "Tchad",
    "es": "Chad"
  },
  "kameroen": {
    "nl": "Kameroen",
    "en": "Cameroon",
    "de": "Kamerun",
    "fr": "Cameroun",
    "es": "Camerún"
  },
  "servie": {
    "nl": "Servië",
    "en": "Serbia",
    "de": "Serbien",
    "fr": "Serbie",
    "es": "Serbia"
  },
  "zuid-sudan": {
    "nl": "Zuid-Sudan",
    "en": "Zuid-Sudan",
    "de": "Zuid-Sudan",
    "fr": "Zuid-Sudan",
    "es": "Zuid-Sudan"
  },
  "samoa": {
    "nl": "Samoa (West Onafhankelijke Staat Samoa)",
    "en": "Samoa (West Onafhankelijke Staat Samoa)",
    "de": "Samoa (West Onafhankelijke Staat Samoa)",
    "fr": "Samoa (West Onafhankelijke Staat Samoa)",
    "es": "Samoa (West Onafhankelijke Staat Samoa)"
  },
  "sri-lanka": {
    "nl": "Sri Lanka",
    "en": "Sri Lanka",
    "de": "Sri Lanka",
    "fr": "Sri Lanka",
    "es": "Sri Lanka"
  },
  "curacao": {
    "nl": "Curaçao",
    "en": "Curaçao",
    "de": "Curaçao",
    "fr": "Curaçao",
    "es": "Curazao"
  },
  "wake-island": {
    "nl": "Wake Island (Verenigde Staten)",
    "en": "Wake Island (Verenigde Staten) (United States)",
    "de": "Wake Island (Verenigde Staten) (Vereinigte Staaten)",
    "fr": "Wake Island (Verenigde Staten) (États-Unis)",
    "es": "Wake Island (Verenigde Staten) (Estados Unidos)"
  },
  "wit-rusland": {
    "nl": "Wit-Rusland",
    "en": "Belarus",
    "de": "Belarus",
    "fr": "Biélorussie",
    "es": "Bielorrusia"
  },
  "verenigd-koninkrijk": {
    "nl": "Verenigd Koninkrijk",
    "en": "United Kingdom",
    "de": "Vereinigtes Königreich",
    "fr": "Royaume-Uni",
    "es": "Reino Unido"
  },
  "verenigde-staten-van-amerika": {
    "nl": "Verenigde Staten van Amerika",
    "en": "Verenigde Staten van Amerika",
    "de": "Vereinigte Staaten von Amerika",
    "fr": "États-Unis",
    "es": "Estados Unidos"
  },
  "noordelijke-marianen": {
    "nl": "Noordelijke Marianen (Verenigde Staten)",
    "en": "Northern Mariana Islands (United States)",
    "de": "Nördliche Marianen (Vereinigte Staaten)",
    "fr": "Îles Mariannes du Nord (États-Unis)",
    "es": "Islas Marianas del Norte (Estados Unidos)"
  },
  "senegal": {
    "nl": "Senegal",
    "en": "Senegal",
    "de": "Senegal",
    "fr": "Sénégal",
    "es": "Senegal"
  },
  "nicaragua": {
    "nl": "Nicaragua",
    "en": "Nicaragua",
    "de": "Nicaragua",
    "fr": "Nicaragua",
    "es": "Nicaragua"
  },
  "maleisie": {
    "nl": "Maleisië",
    "en": "Malaysia",
    "de": "Malaysia",
    "fr": "Malaisie",
    "es": "Malasia"
  },
  "japan": {
    "nl": "Japan",
    "en": "Japan",
    "de": "Japan",
    "fr": "Japon",
    "es": "Japón"
  },
  "lesotho": {
    "nl": "Lesotho",
    "en": "Lesotho",
    "de": "Lesotho",
    "fr": "Lesotho",
    "es": "Lesoto"
  },
  "spanje": {
    "nl": "Spanje (incl. Canarische eilanden)",
    "en": "Spain (incl. Canarische eilanden)",
    "de": "Spanien (inkl. Kanaren) (incl. Canarische eilanden)",
    "fr": "Espagne (Canaries) (incl. Canarische eilanden)",
    "es": "España (Islas Canarias) (incl. Canarische eilanden)"
  },
  "slowakije": {
    "nl": "Slowakije",
    "en": "Slovakia",
    "de": "Slowakei",
    "fr": "Slovaquie",
    "es": "Eslovaquia"
  },
  "zuid-korea": {
    "nl": "Zuid-Korea (Republiek Korea)",
    "en": "Korea, Republic of (Republiek Korea)",
    "de": "Südkorea (Republik Korea) (Republiek Korea)",
    "fr": "Corée du Sud (République de Corée) (Republiek Korea)",
    "es": "Corea del Sur (República de Corea) (Republiek Korea)"
  },
  "tonga": {
    "nl": "Tonga",
    "en": "Tonga",
    "de": "Tonga",
    "fr": "Tonga",
    "es": "Tonga"
  },
  "st-eustatius": {
    "nl": "St Eustatius",
    "en": "St Eustatius",
    "de": "St Eustatius",
    "fr": "St Eustatius",
    "es": "St Eustatius"
  },
  "kenia": {
    "nl": "Kenia",
    "en": "Kenya",
    "de": "Kenia",
    "fr": "Kenya",
    "es": "Kenia"
  },
  "frans-guyana": {
    "nl": "Frans-Guyana",
    "en": "French Guiana",
    "de": "Französisch-Guayana",
    "fr": "Guyane française",
    "es": "Guayana Francesa"
  },
  "salomonseilanden": {
    "nl": "Salomonseilanden (Brits overzees gebied)",
    "en": "Solomon Islands (Brits overzees gebied)",
    "de": "Salomonen (Brits overzees gebied)",
    "fr": "Îles Salomon (Brits overzees gebied)",
    "es": "Islas Salomón (Brits overzees gebied)"
  },
  "estland": {
    "nl": "Estland",
    "en": "Estonia",
    "de": "Estland",
    "fr": "Estonie",
    "es": "Estonia"
  },
  "saba": {
    "nl": "Saba",
    "en": "Saba",
    "de": "Saba",
    "fr": "Saba",
    "es": "Saba"
  },
  "sudan": {
    "nl": "Sudan",
    "en": "Sudan",
    "de": "Sudan",
    "fr": "Sudan",
    "es": "Sudan"
  },
  "panama": {
    "nl": "Panama",
    "en": "Panama",
    "de": "Panama",
    "fr": "Panama",
    "es": "Panamá"
  },
  "st-maarten": {
    "nl": "St Maarten",
    "en": "St Maarten",
    "de": "St Maarten",
    "fr": "St Maarten",
    "es": "St Maarten"
  },
  "indonesie": {
    "nl": "Indonesië",
    "en": "Indonesia",
    "de": "Indonesien",
    "fr": "Indonésie",
    "es": "Indonesia"
  },
  "myanmar": {
    "nl": "Myanmar (voormalig Birma)",
    "en": "Myanmar (voormalig Birma)",
    "de": "Myanmar (voormalig Birma)",
    "fr": "Myanmar (Birmanie) (voormalig Birma)",
    "es": "Myanmar (Birmania) (voormalig Birma)"
  },
  "mali": {
    "nl": "Mali",
    "en": "Mali",
    "de": "Mali",
    "fr": "Mali",
    "es": "Malí"
  },
  "peru": {
    "nl": "Peru",
    "en": "Peru",
    "de": "Peru",
    "fr": "Pérou",
    "es": "Perú"
  },
  "litouwen": {
    "nl": "Litouwen",
    "en": "Lithuania",
    "de": "Litauen",
    "fr": "Lituanie",
    "es": "Lituania"
  },
  "nieuw-zeeland": {
    "nl": "Nieuw-Zeeland",
    "en": "New Zealand",
    "de": "Neuseeland",
    "fr": "Nouvelle-Zélande",
    "es": "Nueva Zelanda"
  },
  "st-helena": {
    "nl": "St Helena (Brits overzees gebied)",
    "en": "St Helena (Brits overzees gebied)",
    "de": "St Helena (Brits overzees gebied)",
    "fr": "St Helena (Brits overzees gebied)",
    "es": "St Helena (Brits overzees gebied)"
  },
  "ivoorkust": {
    "nl": "Ivoorkust",
    "en": "Ivoorkust",
    "de": "Elfenbeinküste",
    "fr": "Côte d'Ivoire",
    "es": "Costa de Marfil"
  },
  "mexico": {
    "nl": "Mexico",
    "en": "Mexico",
    "de": "Mexiko",
    "fr": "Mexique",
    "es": "México"
  },
  "qatar": {
    "nl": "Qatar",
    "en": "Qatar",
    "de": "Katar",
    "fr": "Qatar",
    "es": "Catar"
  },
  "el-salvador": {
    "nl": "El Salvador",
    "en": "El Salvador",
    "de": "El Salvador",
    "fr": "Salvador",
    "es": "El Salvador"
  },
  "thailand": {
    "nl": "Thailand",
    "en": "Thailand",
    "de": "Thailand",
    "fr": "Thaïlande",
    "es": "Tailandia"
  },
  "guyana": {
    "nl": "Guyana",
    "en": "Guyana",
    "de": "Guyana",
    "fr": "Guyana",
    "es": "Guyana"
  },
  "niger": {
    "nl": "Niger",
    "en": "Niger",
    "de": "Niger",
    "fr": "Niger",
    "es": "Níger"
  },
  "seychellen": {
    "nl": "Seychellen",
    "en": "Seychelles",
    "de": "Seychellen",
    "fr": "Seychelles",
    "es": "Seychelles"
  },
  "pakistan": {
    "nl": "Pakistan",
    "en": "Pakistan",
    "de": "Pakistan",
    "fr": "Pakistan",
    "es": "Pakistán"
  },
  "tadzjikistan": {
    "nl": "Tadzjikistan",
    "en": "Tajikistan",
    "de": "Tadschikistan",
    "fr": "Tadjikistan",
    "es": "Tayikistán"
  },
  "uruguay": {
    "nl": "Uruguay",
    "en": "Uruguay",
    "de": "Uruguay",
    "fr": "Uruguay",
    "es": "Uruguay"
  },
  "kaapverdie": {
    "nl": "Kaapverdië",
    "en": "Cape Verde",
    "de": "Kap Verde",
    "fr": "Cap-Vert",
    "es": "Cabo Verde"
  },
  "verenigde-arabische-emiraten": {
    "nl": "Verenigde Arabische Emiraten (incl. Dubai)",
    "en": "United Arab Emirates (incl. Dubai)",
    "de": "Vereinigte Arabische Emirate (incl. Dubai)",
    "fr": "Émirats arabes unis (incl. Dubai)",
    "es": "Emiratos Árabes Unidos (incl. Dubai)"
  },
  "zuid-afrika": {
    "nl": "Zuid-Afrika",
    "en": "South Africa",
    "de": "Südafrika",
    "fr": "Afrique du Sud",
    "es": "Sudáfrica"
  },
  "gibraltar": {
    "nl": "Gibraltar (Brits overzees gebied)",
    "en": "Gibraltar (Brits overzees gebied)",
    "de": "Gibraltar (Brits overzees gebied)",
    "fr": "Gibraltar (Brits overzees gebied)",
    "es": "Gibraltar (Brits overzees gebied)"
  },
  "singapore": {
    "nl": "Singapore",
    "en": "Singapore",
    "de": "Singapur",
    "fr": "Singapour",
    "es": "Singapur"
  },
  "koeweit": {
    "nl": "Koeweit",
    "en": "Kuwait",
    "de": "Kuwait",
    "fr": "Koweït",
    "es": "Kuwait"
  },
  "ijsland": {
    "nl": "IJsland",
    "en": "Iceland",
    "de": "Island",
    "fr": "Islande",
    "es": "Islandia"
  },
  "malawi": {
    "nl": "Malawi",
    "en": "Malawi",
    "de": "Malawi",
    "fr": "Malawi",
    "es": "Malaui"
  },
  "finland": {
    "nl": "Finland",
    "en": "Finland",
    "de": "Finnland",
    "fr": "Finlande",
    "es": "Finlandia"
  },
  "afghanistan": {
    "nl": "Afghanistan",
    "en": "Afghanistan",
    "de": "Afghanistan",
    "fr": "Afghanistan",
    "es": "Afganistán"
  },
  "kiribati": {
    "nl": "Kiribati",
    "en": "Kiribati",
    "de": "Kiribati",
    "fr": "Kiribati",
    "es": "Kiribati"
  },
  "equatoriaal-guinea": {
    "nl": "Equatoriaal-Guinea",
    "en": "Equatorial Guinea",
    "de": "Äquatorialguinea",
    "fr": "Guinée équatoriale",
    "es": "Guinea Ecuatorial"
  },
  "rusland": {
    "nl": "Rusland",
    "en": "Russian Federation",
    "de": "Russische Föderation",
    "fr": "Fédération de Russie",
    "es": "Federación Rusa"
  },
  "nigeria": {
    "nl": "Nigeria",
    "en": "Nigeria",
    "de": "Nigeria",
    "fr": "Nigeria",
    "es": "Nigeria"
  },
  "oost-timor": {
    "nl": "Oost-Timor",
    "en": "Timor-Leste",
    "de": "Timor-Leste",
    "fr": "Timor oriental",
    "es": "Timor Oriental"
  },
  "tsjechie": {
    "nl": "Tsjechië",
    "en": "Czech Republic",
    "de": "Tschechien",
    "fr": "Tchéquie",
    "es": "Chequia"
  },
  "monaco": {
    "nl": "Monaco",
    "en": "Monaco",
    "de": "Monaco",
    "fr": "Monaco",
    "es": "Mónaco"
  },
  "kaaiman-eilanden": {
    "nl": "Kaaiman eilanden (Brits overzees gebied)",
    "en": "Kaaiman eilanden (Brits overzees gebied)",
    "de": "Kaaiman eilanden (Brits overzees gebied)",
    "fr": "Kaaiman eilanden (Brits overzees gebied)",
    "es": "Kaaiman eilanden (Brits overzees gebied)"
  },
  "puerto-rico": {
    "nl": "Puerto Rico (Verenigde Staten)",
    "en": "Puerto Rico (United States)",
    "de": "Puerto Rico (Vereinigte Staaten)",
    "fr": "Porto Rico (États-Unis)",
    "es": "Puerto Rico (Estados Unidos)"
  },
  "montserrat": {
    "nl": "Montserrat (Brits overzees gebied)",
    "en": "Montserrat (Brits overzees gebied)",
    "de": "Montserrat (Brits overzees gebied)",
    "fr": "Montserrat (Brits overzees gebied)",
    "es": "Montserrat (Brits overzees gebied)"
  },
  "gabon": {
    "nl": "Gabon",
    "en": "Gabon",
    "de": "Gabun",
    "fr": "Gabon",
    "es": "Gabón"
  },
  "papoea-nieuw-guinea": {
    "nl": "Papoea-Nieuw-Guinea",
    "en": "Papua New Guinea",
    "de": "Papua-Neuguinea",
    "fr": "Papouasie-Nouvelle-Guinée",
    "es": "Papúa Nueva Guinea"
  },
  "groenland": {
    "nl": "Groenland (Denemarken)",
    "en": "Greenland (Denemarken)",
    "de": "Grönland (Denemarken)",
    "fr": "Groenland (Denemarken)",
    "es": "Groenlandia (Denemarken)"
  },
  "montenegro": {
    "nl": "Montenegro",
    "en": "Montenegro",
    "de": "Montenegro",
    "fr": "Monténégro",
    "es": "Montenegro"
  },
  "zimbabwe": {
    "nl": "Zimbabwe",
    "en": "Zimbabwe",
    "de": "Simbabwe",
    "fr": "Zimbabwe",
    "es": "Zimbabue"
  },
  "duitsland": {
    "nl": "Duitsland",
    "en": "Germany",
    "de": "Deutschland",
    "fr": "Allemagne",
    "es": "Alemania"
  },
  "madagaskar": {
    "nl": "Madagaskar",
    "en": "Madagascar",
    "de": "Madagaskar",
    "fr": "Madagascar",
    "es": "Madagascar"
  },
  "frankrijk": {
    "nl": "Frankrijk",
    "en": "France",
    "de": "Frankreich",
    "fr": "France",
    "es": "Francia"
  },
  "letland": {
    "nl": "Letland",
    "en": "Latvia",
    "de": "Lettland",
    "fr": "Lettonie",
    "es": "Letonia"
  },
  "falkland-eilanden": {
    "nl": "Falkland Eilanden (Brits overzees gebied)",
    "en": "Falkland Eilanden (Brits overzees gebied)",
    "de": "Falkland Eilanden (Brits overzees gebied)",
    "fr": "Falkland Eilanden (Brits overzees gebied)",
    "es": "Falkland Eilanden (Brits overzees gebied)"
  },
  "mozambique": {
    "nl": "Mozambique",
    "en": "Mozambique",
    "de": "Mosambik",
    "fr": "Mozambique",
    "es": "Mozambique"
  },
  "mongolie": {
    "nl": "Mongolië",
    "en": "Mongolia",
    "de": "Mongolei",
    "fr": "Mongolie",
    "es": "Mongolia"
  },
  "mauritanie": {
    "nl": "Mauritanië",
    "en": "Mauritania",
    "de": "Mauretanien",
    "fr": "Mauritanie",
    "es": "Mauritania"
  },
  "marshalleilanden": {
    "nl": "Marshalleilanden",
    "en": "Marshall Islands",
    "de": "Marshallinseln",
    "fr": "Îles Marshall",
    "es": "Islas Marshall"
  },
  "portugal": {
    "nl": "Portugal (incl. Azoren, Madeira)",
    "en": "Portugal (incl. Azoren, Madeira)",
    "de": "Portugal (inkl. Azoren, Madeira) (incl. Azoren, Madeira)",
    "fr": "Portugal (Açores, Madère) (incl. Azoren, Madeira)",
    "es": "Portugal (Azores, Madeira) (incl. Azoren, Madeira)"
  },
  "noorwegen": {
    "nl": "Noorwegen",
    "en": "Norway",
    "de": "Norwegen",
    "fr": "Norvège",
    "es": "Noruega"
  },
  "kroatie": {
    "nl": "Kroatië",
    "en": "Croatia",
    "de": "Kroatien",
    "fr": "Croatie",
    "es": "Croacia"
  },
  "egypte": {
    "nl": "Egypte",
    "en": "Egypt",
    "de": "Ägypten",
    "fr": "Égypte",
    "es": "Egipto"
  },
  "vietnam": {
    "nl": "Vietnam",
    "en": "Vietnam",
    "de": "Vietnam",
    "fr": "Vietnam",
    "es": "Vietnam"
  },
  "libie": {
    "nl": "Libië",
    "en": "Libië",
    "de": "Libië",
    "fr": "Libië",
    "es": "Libië"
  },
  "turkije": {
    "nl": "Turkije",
    "en": "Turkey",
    "de": "Türkei",
    "fr": "Turquie",
    "es": "Turquía"
  },
  "jordanie": {
    "nl": "Jordanië",
    "en": "Jordan",
    "de": "Jordanien",
    "fr": "Jordanie",
    "es": "Jordania"
  },
  "zwitserland": {
    "nl": "Zwitserland",
    "en": "Switzerland",
    "de": "Schweiz",
    "fr": "Suisse",
    "es": "Suiza"
  },
  "ierland": {
    "nl": "Ierland",
    "en": "Ireland",
    "de": "Irland",
    "fr": "Irlande",
    "es": "Irlanda"
  },
  "dominicaanse-republiek": {
    "nl": "Dominicaanse Republiek",
    "en": "Dominican Republic",
    "de": "Dominikanische Republik",
    "fr": "République dominicaine",
    "es": "República Dominicana"
  },
  "noord-korea": {
    "nl": "Noord-Korea (Democratische Volksrepubliek Korea)",
    "en": "Korea, Democratic People’s Republic of (Democratische Volksrepubliek Korea)",
    "de": "Nordkorea (Demokratische Volksrepublik Korea) (Democratische Volksrepubliek Korea)",
    "fr": "Corée du Nord (République populaire démocratique de Corée) (Democratische Volksrepubliek Korea)",
    "es": "Corea del Norte (República Popular Democrática de Corea) (Democratische Volksrepubliek Korea)"
  },
  "luxemburg": {
    "nl": "Luxemburg",
    "en": "Luxembourg",
    "de": "Luxemburg",
    "fr": "Luxembourg",
    "es": "Luxemburgo"
  },
  "venezuela": {
    "nl": "Venezuela",
    "en": "Venezuela",
    "de": "Venezuela",
    "fr": "Venezuela",
    "es": "Venezuela"
  },
  "reunion": {
    "nl": "Réunion (Frans overzees gebied)",
    "en": "Réunion (Frans overzees gebied)",
    "de": "Réunion (Frans overzees gebied)",
    "fr": "La Réunion (Frans overzees gebied)",
    "es": "Reunión (Frans overzees gebied)"
  },
  "swaziland": {
    "nl": "Swaziland",
    "en": "Swaziland",
    "de": "Eswatini",
    "fr": "Eswatini",
    "es": "Esuatini"
  },
  "gambia": {
    "nl": "Gambia",
    "en": "Gambia",
    "de": "Gambia",
    "fr": "Gambie",
    "es": "Gambia"
  },
  "irak": {
    "nl": "Irak",
    "en": "Iraq",
    "de": "Irak",
    "fr": "Irak",
    "es": "Irak"
  },
  "niue": {
    "nl": "Niue (Nieuw-Zeeland)",
    "en": "Niue (New Zealand)",
    "de": "Niue (Neuseeland)",
    "fr": "Niue (Nouvelle-Zélande)",
    "es": "Niue (Nueva Zelanda)"
  },
  "spitsbergen": {
    "nl": "Spitsbergen",
    "en": "Spitsbergen",
    "de": "Spitsbergen",
    "fr": "Spitsbergen",
    "es": "Spitsbergen"
  },
  "iran": {
    "nl": "Iran",
    "en": "Iran, Islamic Republic of",
    "de": "Iran",
    "fr": "Iran",
    "es": "Irán"
  },
  "eritrea": {
    "nl": "Eritrea",
    "en": "Eritrea",
    "de": "Eritrea",
    "fr": "Érythrée",
    "es": "Eritrea"
  },
  "honduras": {
    "nl": "Honduras",
    "en": "Honduras",
    "de": "Honduras",
    "fr": "Honduras",
    "es": "Honduras"
  },
  "filipijnen": {
    "nl": "Filipijnen",
    "en": "Philippines",
    "de": "Philippinen",
    "fr": "Philippines",
    "es": "Filipinas"
  },
  "slovenie": {
    "nl": "Slovenië",
    "en": "Slovenia",
    "de": "Slowenien",
    "fr": "Slovénie",
    "es": "Eslovenia"
  },
  "suriname": {
    "nl": "Suriname",
    "en": "Suriname",
    "de": "Suriname",
    "fr": "Suriname",
    "es": "Surinam"
  },
  "mauritius": {
    "nl": "Mauritius",
    "en": "Mauritius",
    "de": "Mauritius",
    "fr": "Maurice",
    "es": "Mauricio"
  },
  "mayotte": {
    "nl": "Mayotte (Frans overzees gebied)",
    "en": "Mayotte (Frans overzees gebied)",
    "de": "Mayotte (Frans overzees gebied)",
    "fr": "Mayotte (Frans overzees gebied)",
    "es": "Mayotte (Frans overzees gebied)"
  },
  "malta": {
    "nl": "Malta",
    "en": "Malta",
    "de": "Malta",
    "fr": "Malte",
    "es": "Malta"
  },
  "st-pierre-en-miquelon": {
    "nl": "St Pierre en Miquelon (Frans overzees gebied)",
    "en": "St Pierre en Miquelon (Frans overzees gebied)",
    "de": "St Pierre en Miquelon (Frans overzees gebied)",
    "fr": "St Pierre en Miquelon (Frans overzees gebied)",
    "es": "St Pierre en Miquelon (Frans overzees gebied)"
  },
  "oezbekistan": {
    "nl": "Oezbekistan",
    "en": "Uzbekistan",
    "de": "Usbekistan",
    "fr": "Ouzbékistan",
    "es": "Uzbekistán"
  },
  "maldiven": {
    "nl": "Maldiven",
    "en": "Maldives",
    "de": "Malediven",
    "fr": "Maldives",
    "es": "Maldivas"
  },
  "jemen": {
    "nl": "Jemen",
    "en": "Yemen",
    "de": "Jemen",
    "fr": "Yémen",
    "es": "Yemen"
  },
  "guam": {
    "nl": "Guam (Verenigde Staten)",
    "en": "Guam (United States)",
    "de": "Guam (Vereinigte Staaten)",
    "fr": "Guam (États-Unis)",
    "es": "Guam (Estados Unidos)"
  },
  "namibie": {
    "nl": "Namibië",
    "en": "Namibia",
    "de": "Namibia",
    "fr": "Namibie",
    "es": "Namibia"
  },
  "wallis-en-futuna": {
    "nl": "Wallis en Futuna (Frans overzees gebied)",
    "en": "Wallis and Futuna (Frans overzees gebied)",
    "de": "Wallis und Futuna (französisches Überseegebiet) (Frans overzees gebied)",
    "fr": "Wallis-et-Futuna (collectivité française d'outre-mer) (Frans overzees gebied)",
    "es": "Wallis y Futuna (territorio francés de ultramar) (Frans overzees gebied)"
  },
  "somalie": {
    "nl": "Somalië",
    "en": "Somalia",
    "de": "Somalia",
    "fr": "Somalie",
    "es": "Somalia"
  },
  "ethiopie": {
    "nl": "Ethiopië",
    "en": "Ethiopia",
    "de": "Äthiopien",
    "fr": "Éthiopie",
    "es": "Etiopía"
  },
  "san-marino": {
    "nl": "San Marino",
    "en": "San Marino",
    "de": "San Marino",
    "fr": "Saint-Marin",
    "es": "San Marino"
  },
  "st-lucia": {
    "nl": "St Lucia",
    "en": "St Lucia",
    "de": "St Lucia",
    "fr": "St Lucia",
    "es": "St Lucia"
  },
  "paraguay": {
    "nl": "Paraguay",
    "en": "Paraguay",
    "de": "Paraguay",
    "fr": "Paraguay",
    "es": "Paraguay"
  },
  "roemenie": {
    "nl": "Roemenië",
    "en": "Romania",
    "de": "Rumänien",
    "fr": "Roumanie",
    "es": "Rumania"
  },
  "frans-polynesie": {
    "nl": "Frans-Polynesië (incl. Tahiti)",
    "en": "French Polynesia (incl. Tahiti)",
    "de": "Französisch-Polynesien (inkl. Tahiti)",
    "fr": "Polynésie française (incl. Tahiti)",
    "es": "Polinesia Francesa (incl. Tahití)"
  },
  "guinee-bissau": {
    "nl": "Guinee-Bissau",
    "en": "Guinea-Bissau",
    "de": "Guinea-Bissau",
    "fr": "Guinée-Bissau",
    "es": "Guinea-Bisáu"
  },
  "jamaica": {
    "nl": "Jamaica",
    "en": "Jamaica",
    "de": "Jamaika",
    "fr": "Jamaïque",
    "es": "Jamaica"
  },
  "dominica": {
    "nl": "Dominica",
    "en": "Dominica",
    "de": "Dominica",
    "fr": "Dominique",
    "es": "Dominica"
  },
  "cuba": {
    "nl": "Cuba",
    "en": "Cuba",
    "de": "Kuba",
    "fr": "Cuba",
    "es": "Cuba"
  },
  "uganda": {
    "nl": "Uganda",
    "en": "Uganda",
    "de": "Uganda",
    "fr": "Uganda",
    "es": "Uganda"
  },
  "noord-macedonie": {
    "nl": "Noord-Macedonië",
    "en": "North Macedonia",
    "de": "Nordmazedonien",
    "fr": "Macédoine du Nord",
    "es": "Macedonia del Norte"
  }
} as const;
